import React, {Component} from 'react';

class LiabRel extends Component {
    render() {
        return (
            <div className={'liabilityContainer'}>
                <h1 className={"About-Header"}>Liability Release Agreement for PQE-2023</h1>
                <div className={"About-Wrapper"}>
                    <p  className={"About-Content"}>The session will be an educational project in Snowbird, UT, conducted within Cliff Lodge.
                        Participants acknowledge: Wintery conditions in January include freezing temperatures, ice,
                        snow and the possibility of avalanches which may impede or prevent highway entry and/or exit
                        on UT-210, the only highway access between Salt Lake City and Snowbird; non-PQE events at
                        Snowbird include winter alpine activities, which can involve harsh environments including but
                        not limited to ice, obstructions, avalanches, etc., which may result in physical challenges that
                        could cause injury or even death; the elevation of Cliff Lodge is approximately 8,000 feet, which
                        may adversely affect individuals susceptible to altitude sickness and/or other medical conditions;
                        participants are responsible to bring appropriate, clothing, shoes, sunscreen and other articles
                        appropriate for the alpine conditions at Snowbird.</p>

                    <p className={"About-Content"}>
                        It is important for participants to follow the safety directions and instructions given by Snowbird
                        personnel so they will have a safe and enjoyable experience.
                    </p>

                    <p className={"About-Content"}>
                       <b>IN CONSIDERATION OF THE PRECEDING, BY REGISTERING FOR PQE, I AGREE TO
                           BE BOUND TO THE TERMS OF THIS LIABILITY RELEASE, AND I UNDERSTAND
                           THAT I HEREBY RELEASE AND AM HOLDING PQE, ITS OFFICERS, DIRECTORS,
                           EMPLOYEES, COUNSELORS, AND OTHER REPRESENTATIVES HARMLESS AND
                           FREE FROM LIABILITY OF ANY AND ALL ACTS AND OMISSIONS FOR DAMAGES,
                           INJURIES OR ANY CLAIM OF LIABILITY THAT MIGHT ARISE AS A RESULT OF
                           INJURY TO ME ASSOCIATED WITH MY PARTICIPATION IN PHYSICS OF QUANTUM
                           ELECTRONICS 2023 SNOWBIRD CONFERENCE.</b>
                    </p>
                </div>



            </div>
        );
    }
}

export default LiabRel;